import { SUCCESS, FAILURE } from 'middlewares/api-middleware';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import Config from 'config';

export const MAPBOX_REQUEST = Symbol('MAPBOX_REQUEST');

/* eslint-disable no-unused-vars */
export default store => next => (action) => {
  if (!action.meta || !action.meta[MAPBOX_REQUEST]) {
    // non-mapbox requests
    return next(action);
  }
  const { type, payload, meta } = action;
  const { query, params } = payload;
  const geocodingClient = mbxGeocoding({ accessToken: Config.MAPBOX_TOKEN });

  return geocodingClient[query](params)
    .send()
    .then(
      response => next({
        type: type + SUCCESS,
        payload: response,
        meta: {
          ...meta,
          params,
        },
      }),
      error => next({
        type: type + FAILURE,
        payload: error,
        meta,
      })
    );
};



/** WEBPACK FOOTER **
 ** ./src/js/middlewares/mapbox-middleware.js
 **/